import React from 'react'

export const useViewport = () => {
  // Función para obtener el ancho real del viewport
  const getActualWidth = () => {
    if (typeof window !== 'undefined') {
      // En DevTools, window.innerWidth puede ser incorrecto
      // Usamos el menor valor entre las diferentes fuentes para obtener el viewport real
      const windowWidth = window.innerWidth
      const screenWidth = window.screen.width
      const clientWidth = document.documentElement.clientWidth

      // Si estamos en DevTools, clientWidth suele ser el más confiable
      // Si clientWidth es mucho menor que windowWidth, probablemente estamos en DevTools
      const isLikelyDevTools = windowWidth > clientWidth * 2

      return isLikelyDevTools ? clientWidth : Math.min(windowWidth, screenWidth, clientWidth)
    }
    return 1200 // fallback para SSR
  }

  const [width, setWidth] = React.useState(getActualWidth)

  React.useEffect(() => {
    const handleWindowResize = () => setWidth(getActualWidth())
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return { width }
}
